import React, { useState, useEffect } from "react";
import axios from "../../../library/axios";
import { MySwal } from "../../../library/swal";
import Button from "react-bootstrap/Button";
import SelectAccreditation from "react-select";
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const CreateAccreditationComp = (props) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [IdMasterAkreditasi, setIdMasterAkreditasi] = useState("");
  const [TglMulai, setTglMulai] = useState("");
  const [TglBerakhir, setTglBerakhir] = useState("");
  const [SyncSelfAssessment, setSyncSelfAssessment] = useState("");
  const [standardAccreditations, setstandardAccreditations] = useState([]);

  const fetchData = async () => {
    try {
      const options = {
        url: `/standards/list`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      // return false
      setstandardAccreditations([]);
      data.map((d) =>
        setstandardAccreditations((standardAccreditations) => [
          ...standardAccreditations,
          {
            label: d.Nama,
            value: d.id,
          },
        ])
      );
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/accreditations/create.fetchData');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleCreate = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      IdMasterAkreditasi: IdMasterAkreditasi.value,
      TglMulai: TglMulai,
      TglBerakhir: TglBerakhir,
      SyncSelfAssessment: SyncSelfAssessment,
    };
    // console.log(requestBody)
    // return false
    axios({
      url: "/accreditations/create",
      method: "POST",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: "success",
            title: "Success",
            text: "Successfully created new Accreditation!",
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="user" className="col-sm-12 col-form-label required">
          Standard Akreditasi
        </label>
        <div className="col-12">
          <SelectAccreditation
            id="accreditation"
            value={IdMasterAkreditasi}
            onChange={setIdMasterAkreditasi}
            options={standardAccreditations}
            placeholder="Cari"
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="TglMulai" className="col-sm-12 col-form-label required">
          Tgl Mulai Survei
        </label>
        <div className="col-12">
          <input
            type="date"
            className="form-control"
            id="TglMulai"
            onChange={(e) => setTglMulai(e.target.value)}
            value={TglMulai}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label
          htmlFor="TglBerakhir"
          className="col-sm-12 col-form-label required"
        >
          Tgl Berakhir Survei
        </label>
        <div className="col-12">
          <input
            type="date"
            className="form-control"
            id="TglBerakhir"
            onChange={(e) => setTglBerakhir(e.target.value)}
            value={TglBerakhir}
          />
        </div>
      </div>
      <div className="mb-5 row">
        <label
          htmlFor="SyncSelfAssessment"
          className="col-sm-12 col-form-label required"
        >
          Import Self Assessment
        </label>
        <div className="col-12">
          <select
            className="form-control"
            onChange={(e) => setSyncSelfAssessment(e.target.value)}
            value={SyncSelfAssessment}
          >
            <option value="" selected>
              - Pilih -
            </option>
            <option value="Ya">Ya</option>
            <option value="Tidak">Tidak</option>
          </select>
          <small className="text-info">
            Pilih "Ya" jika akan melakukan Import Self Assessment dari SPEAK
            Online.
          </small>
        </div>
      </div>
      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleCreate()}
          >
            {loading === true ? "Mohon Tunggu.." : "Simpan"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateAccreditationComp;
